import { useState } from 'react'

const Forms = () => {
  const [selectedForm, setSelectedForm] = useState(null)

  // Common gradient for all cards
  const cardGradient = 'from-indigo-600 via-purple-600 to-pink-600'
  const cardIconBg = 'bg-indigo-500/20'

  const surveyForms = [
    {
      id: 'cargo-damage',
      title: 'Cargo Damage',
      description: 'Document and assess cargo damage survey form',
      icon: 'bi-exclamation-triangle',
      component: null,
      disabled: true
    },
    {
      id: 'bunker-survey',
      title: 'Bunker Survey',
      description: 'Fuel quantity and quality survey form',
      icon: 'bi-fuel-pump',
      component: null,
      disabled: true
    }
  ]

  const selectedFormData = surveyForms.find(f => f.id === selectedForm)
  const FormComponent = selectedFormData?.component

  const handleFormSelect = (formId) => {
    const form = surveyForms.find(f => f.id === formId)
    if (form?.disabled) {
      return // Don't allow selection of disabled forms
    }
    if (form?.component) {
      setSelectedForm(formId)
    } else {
      alert(`${form?.title} form is coming soon!`)
    }
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div className="mb-6">
        <div className="flex items-center justify-between gap-4">
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold"><span className="text-premium">Survey Forms</span></h1>
            <p className="text-xs sm:text-sm text-gray-500 mt-1">Select a survey form to complete. Use AI image extraction or fill manually.</p>
          </div>
          
          {/* Back Button (when form is selected) - Same Row */}
          {selectedForm && (
            <button
              onClick={() => setSelectedForm(null)}
              className="flex items-center gap-2 px-5 py-2.5 text-gray-700 hover:text-jnj-neon-600 hover:bg-gray-50 rounded-lg transition-colors duration-200 border border-gray-300 hover:border-jnj-neon-500 whitespace-nowrap"
            >
              <i className="bi bi-arrow-left"></i>
              <span>Back to Forms</span>
            </button>
          )}
        </div>
      </div>

      {/* Survey Form Cards - AI Style */}
      {!selectedForm && (
        <div className="mb-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {surveyForms.map((form) => (
              <button
                key={form.id}
                onClick={() => handleFormSelect(form.id)}
                disabled={form.disabled}
                className={`group relative overflow-hidden rounded-2xl border-2 p-6 shadow-lg transition-all duration-300 ${
                  form.disabled 
                    ? `bg-gradient-to-br ${cardGradient} border-transparent opacity-60 cursor-not-allowed` 
                    : `bg-gradient-to-br ${cardGradient} border-transparent hover:shadow-2xl hover:scale-[1.02] hover:rotate-1`
                }`}
              >
                {/* Disabled Overlay */}
                {form.disabled && (
                  <div className="absolute inset-0 bg-gray-900/40 backdrop-blur-[1px] z-20"></div>
                )}
                
                {/* Shimmer Effect - Only for enabled forms */}
                {!form.disabled && (
                  <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-1000"></div>
                )}
                
                {/* Content */}
                <div className={`relative z-10 ${form.disabled ? 'opacity-70' : ''}`}>
                  {/* Icon */}
                  <div className={`${form.disabled ? 'bg-white/10' : 'bg-white/20'} w-16 h-16 rounded-xl flex items-center justify-center mb-4 transition-all duration-300 ${form.disabled ? '' : 'group-hover:scale-110'}`}>
                    <i className={`${form.icon} text-3xl text-white transition-colors duration-300`}></i>
                  </div>
                  
                  {/* Title */}
                  <h3 className="text-xl font-bold mb-2 text-white transition-colors duration-300">
                    {form.title}
                  </h3>
                  
                  {/* Description */}
                  <p className="text-sm text-white/90 transition-colors duration-300">
                    {form.description}
                  </p>
                  
                  {/* Arrow Icon - Only for enabled forms */}
                  {!form.disabled && (
                    <div className="mt-4 flex items-center text-white transition-colors duration-300">
                      <span className="text-sm font-semibold mr-2">Open Form</span>
                      <i className="bi bi-arrow-right group-hover:translate-x-2 transition-transform duration-300"></i>
                    </div>
                  )}
                </div>

                {/* Corner Accent */}
                <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-white/10 to-transparent rounded-bl-full"></div>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Render Selected Form */}
      {FormComponent && <FormComponent />}
      
      {/* Coming Soon Message for forms without components */}
      {selectedForm && !FormComponent && (
        <div className="bg-white rounded-2xl p-12 text-center shadow-lg border-2 border-gray-200">
          <div className={`inline-flex ${cardIconBg} w-24 h-24 rounded-full items-center justify-center mb-6`}>
            <i className={`${selectedFormData?.icon} text-5xl text-gray-400`}></i>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">{selectedFormData?.title} Form</h2>
          <p className="text-gray-600 mb-6">This form is coming soon!</p>
          <button
            onClick={() => setSelectedForm(null)}
            className="px-6 py-2 bg-jnj-neon-500 text-white rounded-lg hover:bg-jnj-neon-600 transition-colors"
          >
            Back to Forms
          </button>
        </div>
      )}
    </div>
  )
}

export default Forms

